import React, { useEffect, useState } from "react";
import { useAppContext } from "./../AppContext"; // Adjust the path as needed

import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import { useHistory, useLocation } from "react-router-dom";
import AdminDashBoard from "../AdminMainPageComps/AdminDashBoard";
import AdminOrdersMP from "../AdminMainPageComps/AdminOrdersMP";
import AdminHeader from "../AdminMainPageComps/AdminHeader";
import AdminProductsMP from "../AdminMainPageComps/AdminProductsMP";
import AdminBrandsMP from "../AdminMainPageComps/AdminBrandsMP";
import AdminNewsMP from "../AdminMainPageComps/AdminNewsMP";
import AdminTownsMP from "../AdminMainPageComps/AdminTownsMP";
import DeliveryDashBoard from "../DeliveryMainPageComps.js/DeliveryDashBoard";
import DeliveryOrdersMP from "../DeliveryMainPageComps.js/DeliveryOrdersMP";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width:
    window.innerWidth >= 1024
      ? `calc(${theme.spacing(7)} + 1px)`
      : `calc(${theme.spacing(0)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function DeliveryMainPage() {
  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const location = useLocation();
  const history = useHistory();
  const theme = useTheme();
  const TheOpen = location.state;
  const { User, OpenDrawerFromAdminHeader, setOpenDrawerFromAdminHeader } =
    useAppContext(TheOpen === undefined ? false : TheOpen);

  const handleDrawerOpen = () => {
    setOpenDrawerFromAdminHeader(true);
    setOpenDrawerFromAdminHeader(true);
  };

  const handleDrawerClose = () => {
    setOpenDrawerFromAdminHeader(false);

    setOpenDrawerFromAdminHeader(false);
  };

  const handleDivClick = (path, shouldOpen) => {
    history.push({
      pathname: path,
      state: shouldOpen,
    });
  };

  const menuItems = [
    { Name: "Dashboard", Path: "/delivery-mainpage/delivery-dashboard" },
    {
      Name: "Orders reports",
      Path: "/delivery-mainpage/delivery-orders-reports",
    },
    // { Name: "Products", Path: "/admin-mainpage/admin-products" },
    // { Name: "Brands", Path: "/admin-mainpage/admin-brands" },
    // { Name: "News", Path: "/admin-mainpage/admin-news" },
    // { Name: "Towns", Path: "/admin-mainpage/admin-towns" },
  ];

  return (
    <div style={{ display: "flex", width: "100%" }}>
      <CssBaseline />
      <AppBar position="fixed" open={OpenDrawerFromAdminHeader}></AppBar>
      <Drawer variant="permanent" open={OpenDrawerFromAdminHeader}>
        <DrawerHeader>
          {OpenDrawerFromAdminHeader ? (
            <ChevronLeftIcon
              style={{ cursor: "pointer" }}
              onClick={handleDrawerClose}
            />
          ) : (
            <ChevronRightIcon
              style={{ cursor: "pointer" }}
              onClick={handleDrawerOpen}
            />
          )}
        </DrawerHeader>
        <Divider />
        <List>
          {menuItems.map((item, index) => {
            const isSelected = location.pathname === item.Path;
            return (
              <ListItem
                key={item.Name}
                disablePadding
                sx={{ display: "block" }}
              >
                <ListItemButton
                  selected={isSelected}
                  onClick={() =>
                    handleDivClick(item.Path, OpenDrawerFromAdminHeader)
                  }
                  sx={[
                    {
                      minHeight: 48,
                      px: 2.5,
                      backgroundColor: isSelected ? "green" : "white",
                      color: isSelected ? "black" : "blue",
                      "&:hover": {
                        backgroundColor: isSelected ? "#a1a1aa" : "#a1a1aa",
                      },
                    },
                    OpenDrawerFromAdminHeader
                      ? { justifyContent: "initial" }
                      : { justifyContent: "center" },
                  ]}
                >
                  <ListItemIcon
                    sx={[
                      {
                        minWidth: 0,
                        justifyContent: "center",
                        color: isSelected ? "inherit" : "black",
                      },
                      OpenDrawerFromAdminHeader ? { mr: 3 } : { mr: "auto" },
                    ]}
                  >
                    {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                  </ListItemIcon>
                  <ListItemText
                    primary={item.Name}
                    sx={[
                      OpenDrawerFromAdminHeader
                        ? { opacity: 1 }
                        : { opacity: 0 },
                      { color: isSelected ? "inherit" : "black" },
                    ]}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Drawer>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          paddingLeft: MyWidth >= 1024 ? "2%" : "0%",
          paddingRight: MyWidth >= 1024 ? "2%" : "0%",
        }}
      >
        <AdminHeader />
        {location.pathname === "/delivery-mainpage/delivery-dashboard" && (
          <DeliveryDashBoard />
        )}
        {location.pathname === "/delivery-mainpage/delivery-orders-reports" && (
          <DeliveryOrdersMP />
        )}
        {/* {location.pathname === "/admin-mainpage/admin-products" && (
          <AdminProductsMP />
        )}
        {location.pathname === "/admin-mainpage/admin-brands" && (
          <AdminBrandsMP />
        )}
        {location.pathname === "/admin-mainpage/admin-news" && <AdminNewsMP />}
        {location.pathname === "/admin-mainpage/admin-towns" && (
          <AdminTownsMP />
        )} */}
      </div>
    </div>
  );
}
